//Convert the width in pixels to a string used for styling
export const convertWidthNum = (width: number, offset: number = 50) => {
  return (width - offset).toString() + 'px';
};
